import React from "react";
import {connect, useDispatch} from "react-redux";
import {useLocation, useNavigate, useParams} from "react-router-dom";

import {Logout} from "../../../store/actions/AuthActions";
import {isAuthenticated} from "../../../store/selectors/AuthSelectors";
import LogoutIcon from "../../../images/icons/logoutIcon";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{location, navigate, params}} />;
  }

  return ComponentWithRouterProp;
}

function LogoutPage(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  function onLogout() {
    dispatch(Logout(navigate));
    // window.location.reload();
  }
  return (
    <>
      <button className="dropdown-item ai-icon" onClick={onLogout}>
        <div className="w-full flex items-center justify-start gap-2 text-[#FF6600]">
          <span className="text-xl">
            <i className="fi fi-rr-sign-out-alt flex items-center"></i>
          </span>
          <span className=" text-[#3D4465]">Déconnexion</span>
        </div>
      </button>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(LogoutPage));
